import { CONTAINER, TYPES } from '../../../config';

import { AuthState, AuthTokenInfo, GetterClass } from '../../../models';

import { AuthTokenService } from '../../../services';

export class TokenInfoGetter implements GetterClass {

  public static execute(state: AuthState): AuthTokenInfo {
    const authTokenService: AuthTokenService = CONTAINER.get<AuthTokenService>(TYPES.AuthTokenService);
    return authTokenService.getInfo(state.token);
  }

}
